import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WithLoader = _resolveComponent("WithLoader")!
  const _component_CommonModal = _resolveComponent("CommonModal")!

  return (_openBlock(), _createBlock(_component_CommonModal, {
    name: _ctx.modalName,
    title: _ctx.$t('How to resume defrosting')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_WithLoader, {
        state: _ctx.userState,
        isPlaceholder: "",
        transitionName: "fade"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.userQualify.qualifyText), 1)
        ]),
        _: 1
      }, 8, ["state"])
    ]),
    _: 1
  }, 8, ["name", "title"]))
}